/** What can be done to an incident. One rule, so no surface offers a button the server refuses. */
export enum IncidentAction {
  resolve = 'resolve',
  close = 'close',
  reopen = 'reopen',
}

/** The two fields the rule reads, so a list row answers it as well as a whole incident does. */
export interface DecidableIncident {
  resolvedAt: string | null;
  closedAt: string | null;
}

/** What this incident offers, in the order it should be offered. */
export const incidentActionsFor = (incident: DecidableIncident): IncidentAction[] => {
  if (incident.closedAt) return [IncidentAction.reopen];
  if (incident.resolvedAt) return [IncidentAction.close];
  return [IncidentAction.resolve];
};
